<template>
	<div :class="['c-picker-search', { active: query.length > 0 }]">
		<input type="text" name="search" v-model="query" placeholder="Search for boards" />
		<svg @click="close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z"
				fill="currentColor"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			query: '',
		};
	},

	watch: {
		query: function () {
			this.$emit('query', this.query);
		},
	},

	props: {},

	computed: {},

	methods: {
		close: function () {
			this.query = '';
		},
		onClick: function (e) {
			e.target.focus();
		},
		onBlur: function () {
			this.$el.querySelector('input').blur();
		},
	},
};
</script>

<style lang="scss">
.c-picker-search {
	padding: 4px;
	display: grid;
	grid-template-columns: 1fr 28px;
	align-items: center;

	svg {
		margin-left: 4px;
		opacity: 0.5;
		cursor: pointer;
	}

	&.active {
		svg {
			opacity: 1;
			color: #e45129;
		}
	}
}
</style>
